<template>
  <div class="skeleton-filter-bar">
    <div class="skeleton-inner-filter-bar">
      <div class="skeleton-left-filters">
        <v-skeleton-loader
          type="text"
          width="42"
          class="mr-4"
        />
        <v-skeleton-loader
          type="text"
          width="51"
          class="mr-4"
        />
        <v-skeleton-loader
          type="text"
          width="105"
          class="mr-4"
        />
        <v-skeleton-loader
          type="text"
          width="165"
        />
      </div>
      <div class="skeleton-right-filters">
        <v-skeleton-loader
          type="text"
          width="73"
          class="mr-4"
        />
        <v-skeleton-loader
          type="text"
          width="87"
          class="mr-4"
        />
        <v-skeleton-loader
          type="text"
          width="55"
          class="mr-4"
        />
        <v-skeleton-loader
          type="text"
          width="145"
        />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.skeleton-filter-bar {
  width: 100%;
  margin-top: 12px;
}

.skeleton-inner-filter-bar {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  :deep(.v-skeleton-loader) {
    background: transparent;
  }
}

:deep(.v-skeleton-loader__text) {
  margin: 0;
}

.skeleton-left-filters {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.skeleton-right-filters {
  display: flex;
  align-items: center;
  padding-left: 44px;
  justify-content: flex-end;
}

</style>
